<template>
  <div id="app">

    <NavBar/>

    <keep-alive include="deviceList">

      <router-view/>

    </keep-alive>

  </div>
</template>


<script>

import NavBar from '@/components/NavBar.vue'


export default {
  components: {
    NavBar
  }
}
</script>


<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
